var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    { staticClass: "trbo-a-question-back-button", on: { click: _vm.onClick } },
    [
      _c("icon", {
        staticClass: "trbo-a-question-back-button__icon",
        attrs: { name: "back" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "trbo-a-question-back-button__title" }, [
        _vm._v("\n    " + _vm._s(_vm.$t("wizard.back")) + "\n  "),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }